//DOC: https://cv-vinbdi.atlassian.net/wiki/spaces/VinDrPACs/pages/235864125/Message+List

const error_message = {
  EMSG_0001: `Something went wrong. Please try again or contact admin for support.`,
  EMSG_0002: `You do not have permission. Please try again or contact admin for support.`,
  EMSG_0003: `Invalid authorization header`,
  EMSG_0004: `Keys are empty`,
  EMSG_1001: `This user is already part of another institution.`,
  EMSG_2001: `The institution code is already in use.`,
  EMSG_2002: `Please upload a file smaller than 1.5MB.`,
  EMSG_2003: `Institution ID not found`,
  EMSG_3001: `The role code is already in use.`,
  EMSG_3002: `Role ID not found`,
  EMSG_3003: `Cannot delete default roles`,
  EMSG_3004: `The role name is already in use.`,
  EMSG_4001: `The username is already in use.`,
  EMSG_4002: `Please upload a file smaller than 1.5MB.`,
  EMSG_4003: `The group account name is already in use.`,
  EMSG_4004: `User not found`,
  EMSG_5001: `Study ID not found`,
  EMSG_5002: `Failed to sync match status to the study list`,
  EMSG_6001: `The procedure group name is already in use.`,
  EMSG_6002: `The procedure code is already in use.`,
  EMSG_7001: `The template report code is already in use.`,
  EMSG_8001: `Invalid patient ID, please choose the correct Patient ID.`,
  EMSG_8002: `Order is already in use.`,
  EMSG_8003: `Order ID not found`,
  EMSG_8004: `Order status is matched. Please unmatch it first.`,
  EMSG_8005: `Failed to match order with study.`,
  EMSG_8006: `Failed to unmatch order with study.`,
  EMSG_8007: `Failed to sync order status.`,
  EMSG_8008: `Visit ID is already in use. Please enter a different value or leave it blank.`,
  EMSG_8009: `Order ID is already in use. Please enter a different value or leave it blank.`,
  EMSG_8010: `Cannot auto-generate ID. Please try again or contact admin for support.`,
  EMSG_8011: `Cannot assign procedures to order. Please enter valid procedures.`,
  EMSG_8012: `Cannot assign device to order. Please enter a valid device.`,
  EMSG_8013: `Invalid patient ID. Please enter a valid patient ID or leave it blank.`,
  EMSG_8014: `Failed to receive data.`,
  EMSG_8015: `Institution mismatch. Please select the correct institution.`,
  EMSG_8016: `Invalid order status. Please select 'New' or 'Cancel'.`,
  EMSG_8017: `Invalid order status.`,
  EMSG_8018: `Please select a procedure.`,
  EMSG_8019: `Cannot delete an order with status 'ARRIVED'.`,
  EMSG_8020: `Duplicate request on create/update.`,
  EMSG_8021: `Invalid order status`,
  EMSG_9001: `The layout report name is already in use.`,
  EMSG_9002: `Layout ID not found`,
  EMSG_9003: `Layout name not found`,
  EMSG_10000: `Approve all reports before creating a new one.`,
  EMSG_10001: `Report not found`,
  EMSG_10002: `Invalid report action flow.`,
  EMSG_10003: `Another doctor is reading this report.`,
  EMSG_10004: `Failed to cancel report.`,
  EMSG_10005: `Not found report version`,
  EMSG_13001: `The device name is already in use.`,
  EMSG_14001: `Failed to share study.`,
  EMSG_14002: `Failed to update shared study.`,
  EMSG_14003: `Cannot delete expired shared study.`,
  EMSG_14004: `Limited study share for this month.`,
  EMSG_14005: `Invalid institution for sharing study.`,
  EMSG_14006: `Shared study has expired.`,
  EMSG_14007: `Invalid access type for sharing study.`,
  EMSG_15001: `The filter name is already in use.`,
  EMSG_15002: `Filter not found`,
  EMSG_16001: `Failed to create CAD rule.`,
  EMSG_16002: `Failed to update CAD rule.`,
  EMSG_16003: `Failed to delete CAD rule.`,
  EMSG_16004: `Cannot find CAD rule.`,
  EMSG_17001: `Cannot update a request marked as "reading" or "completed".`,
  EMSG_17002: `Cannot delete a request marked as "reading" or "completed".`,
  EMSG_17003: `Please choose a group account.`,
  EMSG_17004: `Please choose an account.`,
  EMSG_18001: `Cannot delete all data. Please contact support.`,
  EMSG_18002: `This order request is invalid.`,
  EMSG_19001: `Cannot create or reset password. Please contact admin for support.`,
  EMSG_19002: `Cannot create or reset password. Please update the phone number.`,
  EMSG_19003: `Invalid institution ID. Please contact admin for support.`,
  EMSG_20001: `The body part name is already in use.`,
  EMSG_20002: `Missing upload action or file name.`,
  EMSG_20003: `Action upload not found or doesn't exist`,
  EMSG_20004: `Invalid request params`,
  EMSG_20005: `Failed to send metadata to S3.`,
  EMSG_29001: `Not found recorded annotation`,
  EMSG_29002: `Fail to update this recorded annotation`,
  EMSG_29003: `Fail to create this recorded annotation`,
  EMSG_29004: `Fail to get the recorded annotation`,
  EMSG_29005: `Wrong owner of this recorded annotation`,
  EMSG_29006: `Fail to delete recorded annotation`,
  EMSG_29007: `Not found valid study to perform`,
  EMSG_32001: `Not found app key`,
  EMSG_31001: `The element has already been used`,
  EMSG_31002: `This element cannot be added to itself`,
  EMSG_31003: `Report element not found`,
  EMSG_31004: `Not all linked element are exist`,
  EMSG_31005: `Generated number is empty`,
  EMSG_31006: `This structure report code has already been used`,
  EMSG_31007: `Generated number must equal or greater than zero`,
  EMSG_31008: `Require detail label for element type Generated List`,
  EMSG_33001: `A digital signature request already exists. Please cancel the signature process before creating a new report`,
  EMSG_33002: `Not found esign order`,
  EMSG_33003: `Invalid Esign status: Signed (Submitter), Failed (Approver), Signed (Approver)`,
  EMSG_33004: `Invalid e-Esign revoke workflow`,
  EMSG_33005: `Invalid Esign status: Failed (Submitter), Failed (Approver), Revoke Fail`,
  EMSG_30001: `Fail to create this consultation`,
  EMSG_30002: `Fail to update this consultation`,
  EMSG_30003: `Fail to cancel this consultation`,
  EMSG_30004: `Consultation session already exists. Hosting By`,
  EMSG_30005: `Consultation session does not exists`,
  EMSG_30006: `Your request cannot be processed because there is already a similar request from another user.`,
  EMSG_30007: `Your request has been submitted and is awaiting confirmation`,
  EMSG_30008: `You have been disconnected from the meeting. Attempting to reconnect...`,
  EMSG_30009: `The host [Host's Name] has been disconnected. Waiting for the host to reconnect...`,
  EMSG_30010: `This account is active on another device. Please leave the session there to continue on this browser.`,
  EMSG_30011: `A maximum of 20 users can be added to the consultation.`,
  EMSG_30012: `A maximum of 20 studies can be added to the consultation.`,
  EMSG_30013: `Consultation session not found.`,
  EMSG_30014: `This note is being modified by`,
  EMSG_30015: `User is not in the consultation participant list.`,
  EMSG_30017: `Duplicate email. Please enter a unique email.`,
  EMSG_30019: `Cannot Connect. The consultation is not in 'Scheduled' status.`,
  EMSG_31009: `Require image with for element type Image`,
  EMSG_31010: `Require image height for element type Image`,
  EMSG_34001: `Invalid QMS status. Please choose status is Waiting or Missed Call`,
  EMSG_34002: `Invalid QMS status. Please choose status is In Progress`,
  EMSG_34003: `Invalid QMS status. Please choose status is Waiting or In Progress`,
  EMSG_34006: `The QMS name already exists in the QMS configuration.`,
  EMSG_34007: `The device already has a QMS configuration.`,
  EMSG_34008: `QMS Default has not been configured.`,
  EMSG_34009: `The QMS configuration does not exist. Please check with the administrator.`,
  EMSG_34010: `The QMS configuration has already been used`,
};

const inline_error_message = {
  IEM_0001: `Please fill value in this field.`,
  IEM_2001: `Enter in the format: name@example.com`,
  IEM_2002: `Enter at least 10 numbers and allow the character +`,
  IEM_4000: `Password must be at least 8 characters long`,
  IEM_4001: `The password confirmation does not match`,
  IEM_4002: `Enter in the format: name@example.com`,
  IEM_4003: `Enter at least 10 numbers and allow the character +`,
  IEM_4004: `The password is incorrect`,
};

const confirmation_dialog = {
  CFD_2000: `Are you sure you want to delete the institution?`,
  CFD_3000: `Are you sure you want to delete the role?`,
  CFD_4000: `Are you sure you want to delete the user?`,
  CFD_4001: `Are you sure you want to delete the group account?`,
  CFD_5000: `Are you sure you want to unmatch the order?`,
  CFD_6000: `Are you sure you want to delete the procedure group?`,
  CFD_6001: `Are you sure you want to delete the procedure?`,
  CFD_7000: `Are you sure you want to delete the template report?`,
  CFD_8000: `Are you sure you want to delete the order?`,
  CFD_9000: `Are you sure you want to delete the layout report?`,
  CFD_10000: `This template will overwrite your current work. Do you want to continue?`,
  CFD_13000: `Are you sure you want to delete the device?`,
  CFD_14000: `Are you sure you want to delete the shared study?`,
  CFD_15000: `Are you sure you want to delete this filter?`,
  CFD_16000: `Are you sure you want to delete this CAD rule?`,
  CFD_17000: `Are you sure you want to delete this request?`,
  CFD_19000: `Are you sure you want to delete the patient?`,
  CFD_19001: `Are you sure you want to reset the password?`,
  CFD_20000: `Are you sure you want to delete the body part?`,
  CFD_21000: `Are you sure you want to delete the department?`,
  CFD_31000: `Are you sure you want to delete the element?`,
  CFD_31001: `Are you sure you want to delete the template structure report?`,
  CFD_32000: `Are you sure you want to delete this request?`,
  CFD_33000: `Are you sure you want to delete this request?`,
  CFD_33001: `Are you sure you want to revoke this request?`,
  CFD_30000: `Are you sure you want to cancel this consultation?`,
  CFD_30001: `Are you sure you want to leave this consultation?`,
  CFD_30002: `You have been disconnected from the meeting. Attempting to reconnect...`,
  CFD_30003: `The host [{{ host_name }}] has been disconnected. Waiting for the host to reconnect...`,
  CFD_30004: `Are you sure you want to delete this note?`,
  CFD_30005: `Are you sure you want to complete this consultation?`,
  CFD_33002: `You have received a host request from [{{ request_name }}]`,
  CFD_33003: `Your host request has been accepted by [{{ host_name }}]. You can start now.`,
  CFD_33004: `Your host request has been denied by [{{ host_name }}]`,
  CFD_33005: `The host has left the room.`,
  CFD_34000: `Are you sure you want to delete the QMS?`,
};

const success_message = {
  SCD_2000: `The institution has been created.`,
  SCD_2001: `The institution has been updated.`,
  SCD_2002: `The institution has been deleted.`,
  SCD_3000: `The role has been created.`,
  SCD_3001: `The role has been updated.`,
  SCD_3002: `The role has been deleted.`,
  SCD_4000: `The account has been created.`,
  SCD_4001: `The account has been updated.`,
  SCD_4002: `The account has been deleted.`,
  SCD_4003: `The group account has been created.`,
  SCD_4004: `The group account has been updated.`,
  SCD_4005: `The group account has been deleted.`,
  SCD_5000: `All orders have been matched.`,
  SCD_5001: `All orders have been unmatched.`,
  SCD_6000: `The procedure group has been created.`,
  SCD_6001: `The procedure group has been updated.`,
  SCD_6002: `The procedure group has been deleted.`,
  SCD_6003: `The procedure has been created.`,
  SCD_6004: `The procedure has been updated.`,
  SCD_6005: `The procedure has been deleted.`,
  SCD_7000: `The template report has been created.`,
  SCD_7001: `The template report has been updated.`,
  SCD_7002: `The template report has been deleted.`,
  SCD_8000: `The order has been created.`,
  SCD_8001: `The order has been updated.`,
  SCD_8002: `The order has been deleted.`,
  SCD_8003: `You can use this patient ID.`,
  SCD_8004: `The order has been received.`,
  SCD_8005: `The patient has been updated.`,
  SCD_8006: `The patient has been updated.`,
  SCD_9000: `The layout report has been created.`,
  SCD_9001: `The layout report has been updated.`,
  SCD_9002: `The layout report has been deleted.`,
  SCD_10000: `The report has been created.`,
  SCD_10001: `The report has been updated.`,
  SCD_10002: `The report has been deleted.`,
  SCD_13000: `The device has been created.`,
  SCD_13001: `The device has been updated.`,
  SCD_13002: `The device has been deleted.`,
  SCD_14001: `The study has been shared.`,
  SCD_14002: `The shared study has been updated.`,
  SCD_14003: `The shared study has been deleted.`,
  SCD_15001: `The filter has been created.`,
  SCD_15002: `The filter has been updated.`,
  SCD_15003: `The filter has been deleted.`,
  SCD_16001: `The CAD rule has been created.`,
  SCD_16002: `The CAD rule has been updated.`,
  SCD_16003: `The CAD rule has been deleted.`,
  SCD_17001: `The request has been assigned.`,
  SCD_17002: `The request has been updated.`,
  SCD_17003: `The request has been deleted.`,
  SCD_18001: `The key image has been created.`,
  SCD_18002: `The data has been deleted.`,
  SCD_19001: `The patient account has been created.`,
  SCD_19002: `The patient account has been updated.`,
  SCD_19003: `The patient account has been deleted.`,
  SCD_20000: `The body part has been created.`,
  SCD_20001: `The body part has been updated.`,
  SCD_20002: `The body part has been deleted.`,
  SCD_21000: `The department has been created.`,
  SCD_21001: `The department has been updated.`,
  SCD_21002: `The department has been deleted.`,
  SCD_25001: `The print job has been created.`,
  SCD_31001: `The element has been created.`,
  SCD_31002: `The element has been updated.`,
  SCD_31003: `The element has been deleted.`,
  SCD_31006: `The template structure report has been created.`,
  SCD_31007: `The template structure report has been updated.`,
  SCD_31008: `The template structure report has been deleted.`,
  SCD_32001: `The resend request has been created.`,
  SCD_32002: `The request has been deleted.`,
  SCD_33001: `The digital signature request has been created.`,
  SCD_33002: `The resend request has been created.`,
  SCD_33003: `The request has been deleted.`,
  SCD_33004: `The revocation request has been created.`,
  SCD_30001: `The consultation has been created.`,
  SCD_30002: `The consultation has been created.`,
  SCD_30003: `The consultation has been updated.`,
  SCD_30004: `The consultation has been canceled.`,
  SCD_30005: `The note has been created.`,
  SCD_30006: `The note has been updated.`,
  SCD_30007: `The note has been deleted.`,
  SCD_30008: `The consultation has been completed.`,
  SCD_34001: `The QMS has been created.`,
  SCD_34002: `The QMS has been updated.`,
  SCD_34003: `The QMS has been deleted.`,
  SCD_34004: `The order has been successfully updated into the QMS.`,
  SCD_34005: `Patient information not found.`,
  SCD_34006: `Queue order updated successfully.`,
  SCD_34007: `The QMS profile has been updated.`,
};

export const MESSAGE = Object.freeze({
  ERROR: error_message,
  INLINE: inline_error_message,
  DIALOG: confirmation_dialog,
  SUCCESS: success_message,
});
